





























































import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class PracticeDummy2 extends Vue {
  private mounted() {
    let scriptEl = document.createElement('script')
    scriptEl.setAttribute('src', '/dummy/practice/js/2.js')
    ;(document.getElementById('contentsarea2') as HTMLElement).appendChild(scriptEl)
  }
}
